import { useAtomValue, useSetAtom } from 'jotai'
import global from './modules/global'

export function useGlobalValue() {
  return useAtomValue(global)
}

export function useGlobalSet() {
  return useSetAtom(global)
}
